export const getClairetteFranceData = () => ({
  name: "Clairette",
  country: "France",
  description: "Clairette est un cépage blanc très ancien originaire du sud de la France, cultivé dans de nombreuses appellations où il produit des vins blancs frais et aromatiques.",
  regions: [
    { name: "Châteauneuf-du-Pape", area: "25 ha", percentage: "0.3%", description: "Cépage blanc traditionnel, apportant fraîcheur et acidité" },
    { name: "Clairette de Die", area: "1,500 ha", percentage: "90%", description: "Appellation dédiée, vins effervescents" },
    { name: "Côtes du Rhône", area: "300 ha", percentage: "3%", description: "Cépage blanc important dans les assemblages" },
    { name: "Languedoc-Roussillon", area: "500 ha", percentage: "2%", description: "Cultivé dans de nombreuses appellations" },
    { name: "Provence", area: "200 ha", percentage: "1%", description: "Utilisé dans les rosés et vins blancs" }
  ],
  mapAreas: [
    { region: "Châteauneuf-du-Pape", x: 52, y: 68, color: "#4B164C", size: 1 },
    { region: "Clairette de Die", x: 53, y: 67, color: "#6d2c7a", size: 4 },
    { region: "Côtes du Rhône", x: 50, y: 65, color: "#8a4a8a", size: 2 },
    { region: "Languedoc", x: 48, y: 62, color: "#a768a6", size: 3 },
    { region: "Provence", x: 46, y: 60, color: "#c484c4", size: 2 }
  ],
  characteristics: {
    viticulture: "Cépage vigoureux, résistant à la sécheresse, sensible à l'oxydation",
    climate: "Préfère les climats chauds et secs du sud de la France",
    soil: "Sols calcaires et argileux, bien drainés"
  },
  wineStyles: {
    white: "Vins blancs frais avec des notes d'agrumes et une acidité vive",
    sparkling: "Vins effervescents aromatiques (Clairette de Die)"
  },
  foodPairing: "Poissons, fruits de mer, volailles, fromages frais, cuisine provençale",
  history: "Clairette est un cépage blanc très ancien, mentionné dans les textes romains. Son nom évoque la clarté et la transparence de ses vins. Il est cultivé dans de nombreuses appellations du sud de la France et est particulièrement célèbre pour les vins effervescents de Clairette de Die."
}); 